// removed by extract-text-webpack-plugin
module.exports = {"accordeon":"_1FjOs_SOlMa2D7rzYvHhjN","title":"_1BcBhXVVP7CXHXdU-IDWa3","triangleRight":"_3IoaQTbVBv1Db7FQWH42nT","triangleDown":"_2zh2ocUPA5bKrxhQBakkXj","closed":"_3JRXUMi0kjx5FFBJ13YiOD"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/modules/americanFootball/css/accordion.css
// module id = 874
// module chunks = 0